import React from "react";
import { Col, Container, Row } from "react-bootstrap";

function storiesgcc({ rtl }) {
  const className = rtl
    ? "normal_section p-100 rtl-style"
    : "normal_section p-100";
  return (
    <div className={className}>
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="offset-lg-1">
            <h2>قصص نجاح من شركة تطوير التطبيقات لدينا</h2>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <p>
              اكتسبت TekRevol مكانة موثوقة في صناعة التكنولوجيا العالمية بفضل
              منتجاتها المتطورة لتطوير تطبيقات الهاتف المحمول، والمصممة لخدمة
              الشركات في جميع أنحاء العالم. تشهد العديد من الشركات التي تستخدم
              تقنيتنا المتقدمة باستمرار نموًا هائلاً في عائد استثمارها مع زيادة
              إيراداتها الإجمالية. فيما يلي بعض الحلول الشائعة التي قدمناها
              أدناه حتى تتمكن من أن تشهد بنفسك أننا شركة موثوقة في تطوير تطبيقات
              الأجهزة المحمولة.
            </p>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default storiesgcc;
